import React, { Component } from 'react'
import Terms from './Terms'
import Legal from './Legal'
import { redbit } from '../../assets/images'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import Config from '../../Config'

class Footer extends Component {
  render () {
    const appContent = this.props.appContent.content
    return (
      <div className='footer'>
        <Terms appContent={appContent.terms}/>|
        <Legal appContent={appContent.legal}/>

        {Config.hideRedBit &&
          <div className='redbit' style={{ height: 5 }}>
          </div>
        }

        {!Config.hideRedBit &&
          <div className='redbit'>
            <a target='_blank' rel='noopener noreferrer' href='http://www.redbitdev.com?utm_source=nexgenrx_memberweb'><img src={redbit} alt='Built by Redbit' /></a>
          </div>
        }
      </div>
    )
  }
}

function mapStateToProps (state, ownProps) {
  return {
    appContent: state.AppContentReducer.appContent
  }
}

const ConnectedFooter = connect(mapStateToProps, {})(injectIntl(Footer))

export default ConnectedFooter



// WEBPACK FOOTER //
// ./src/widgets/common/Footer.js